var isEmpty = require('lodash').isEmpty;

module.exports = function (hosts) {
  if (isEmpty(hosts)) return false;

  var commonProtocol = hosts.shift().protocol;
  for (var i = 0; i < hosts.length; i++) {
    if (commonProtocol !== hosts[i].protocol) {
      return false;
    }
  }

  return commonProtocol;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/elasticsearch/src/lib/transport/find_common_protocol.js
// module id = ./node_modules/elasticsearch/src/lib/transport/find_common_protocol.js
// module chunks = vendor